import { TILE_SIZE, MAP_WIDTH, MAP_HEIGHT } from '../config.js';

// Tile types
export const TILE_TYPES = {
    WATER: 0,
    LAND: 1
};

// Biome types
export const BIOME_TYPES = {
    WATER: 0,
    BEACH: 1,
    PLAINS: 2,
    FOREST: 3,
    MOUNTAINS: 4
};

class TileManager {
    constructor() {
        this.tiles = new Array(MAP_WIDTH);
        for (let x = 0; x < MAP_WIDTH; x++) {
            this.tiles[x] = new Array(MAP_HEIGHT);
            for (let y = 0; y < MAP_HEIGHT; y++) {
                this.tiles[x][y] = {
                    type: TILE_TYPES.WATER,
                    height: 0,
                    biome: BIOME_TYPES.WATER
                };
            }
        }
        this.showTileBorders = false;
        this.showMinimap = false;
    }

    reset() {
        // Reset all tiles to water
        for (let x = 0; x < MAP_WIDTH; x++) {
            for (let y = 0; y < MAP_HEIGHT; y++) {
                this.tiles[x][y] = {
                    type: TILE_TYPES.WATER,
                    height: 0,
                    biome: BIOME_TYPES.WATER
                };
            }
        }
        this.showTileBorders = false;
        this.showMinimap = false;
    }

    getTile(x, y) {
        if (x < 0 || x >= MAP_WIDTH || y < 0 || y >= MAP_HEIGHT) {
            return null;
        }
        return this.tiles[x][y];
    }

    setTile(x, y, type, height, biome) {
        if (x < 0 || x >= MAP_WIDTH || y < 0 || y >= MAP_HEIGHT) {
            return;
        }
        this.tiles[x][y] = {
            type,
            height,
            biome
        };
    }

    getTileAtPosition(worldX, worldY) {
        const tileX = Math.floor(worldX / TILE_SIZE);
        const tileY = Math.floor(worldY / TILE_SIZE);
        return this.getTile(tileX, tileY);
    }

    getTilesInChunk(chunkX, chunkY, chunkSize) {
        const tiles = [];
        const startX = chunkX * chunkSize;
        const startY = chunkY * chunkSize;
        
        for (let x = startX; x < startX + chunkSize; x++) {
            for (let y = startY; y < startY + chunkSize; y++) {
                const tile = this.getTile(x, y);
                if (tile) {
                    tiles.push({
                        x,
                        y,
                        ...tile
                    });
                }
            }
        }
        
        return tiles;
    }

    getTilesInChunkRing(centerChunkX, centerChunkY, chunkSize, radius) {
        const tiles = [];
        const addedTileKeys = new Set(); // Prevent adding the same tile twice

        // Loop from -radius to +radius around the center chunk
        for (let dx = -radius; dx <= radius; dx++) {
            for (let dy = -radius; dy <= radius; dy++) {
                const chunkX = centerChunkX + dx;
                const chunkY = centerChunkY + dy;

                // Get tiles from this chunk
                const chunkTiles = this.getTilesInChunk(chunkX, chunkY, chunkSize);
                
                 // Add tiles, ensuring no duplicates
                 for (const tile of chunkTiles) {
                     const key = `${tile.x},${tile.y}`;
                     if (!addedTileKeys.has(key)) {
                        tiles.push(tile);
                        addedTileKeys.add(key);
                     }
                 }
            }
        }

        // Center chunk is included in the loop now
        
        return tiles;
    }

    toggleTileBorders() {
        this.showTileBorders = !this.showTileBorders;
        console.log('Tile borders:', this.showTileBorders ? 'ON' : 'OFF');
    }

    toggleMinimap() {
        this.showMinimap = !this.showMinimap;
        console.log('Minimap:', this.showMinimap ? 'ON' : 'OFF');
    }
}

export const tileManager = new TileManager(); 